// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2chZD","option":"styles_option__1sXG7","selected":"styles_selected__2YS8y"};